import { Phone, Mail, Facebook, Instagram, Twitter } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useContent } from "@/context/ContentContext";
import { pushEvent } from "@/lib/api";

export default function Footer() {
  const { content } = useContent();
  const phone = content.phone || "(310) 508-6563";
  const telHref = `tel:${phone.replace(/[^0-9+]/g, "")}`;

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-8 border-b border-white/10 pb-8 md:flex-row md:items-center">
          <div>
            <Logo dark white />
            <p className="mt-3 max-w-xs text-base text-slate-400">
              Professional interior & exterior house painting done right the first time. Licensed,
              insured, and guaranteed.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <a id="observeThis" href={telHref} onClick={() => pushEvent("PaintingCall", { phone, location: "footer" })} className="phoneLink flex items-center gap-2 text-base font-semibold text-slate-200 transition-colors hover:text-[#2563EB]" data-testid="footer-phone">
              <Phone className="h-4 w-4 text-[#2563EB]" /> {phone}
            </a>
            <a href="mailto:salsconstruction310@gmail.com" className="flex items-center gap-2 text-base font-semibold text-slate-200 transition-colors hover:text-[#2563EB]" data-testid="footer-email">
              <Mail className="h-4 w-4 text-[#2563EB]" /> salsconstruction310@gmail.com
            </a>
          </div>
        </div>
        <div className="flex flex-col items-center justify-between gap-4 pt-6 sm:flex-row">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} ColorStone Home Painting Co. All rights reserved. CSLB #8867273
          </p>
          <div className="flex items-center gap-4">
            <a href="/admin/login" className="text-sm text-slate-500 hover:text-slate-300">Admin</a>
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-sm text-slate-500 hover:text-slate-300">Privacy Policy</Link>
            <div className="flex gap-2">
              {[
                { Icon: Facebook, label: "Facebook" },
                { Icon: Instagram, label: "Instagram" },
                { Icon: Twitter, label: "Twitter" },
              ].map(({ Icon, label }, i) => (
                <a key={i} href="#top" aria-label={`ColorStone on ${label}`} data-testid={`footer-social-${label.toLowerCase()}`} className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-slate-300 transition-colors hover:bg-[#2563EB] hover:text-white">
                  <Icon className="h-4 w-4" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
